var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInquiryChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 149.477,
    height: 149.212,
    viewBox: "0 0 149.477 149.212",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42626",
    "data-name": "Group 42626",
    transform: "translate(-165.122 -216.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21122",
    "data-name": "Path 21122",
    d: "M314.6,291.42A74.726,74.726,0,0,1,246.581,365.7a75.719,75.719,0,0,1-42.732-8.666,7.87,7.87,0,0,0-4.931-.57c-4.542.987-8.99,2.408-13.494,3.576-10,2.585-16.778-4.152-14.18-14.1,1.174-4.5,2.586-8.953,3.579-13.494a7.794,7.794,0,0,0-.526-4.95c-24.565-45.825,2.489-100.986,53.881-109.7,41.187-6.981,81.141,23.325,85.676,65C314.165,285.67,314.355,288.548,314.6,291.42ZM181.249,350.049c6.38-1.685,12.09-3.056,17.709-4.735a9.486,9.486,0,0,1,8.18,1.143c13.186,7.825,27.487,10.707,42.57,8.118,35.078-6.018,57.4-36.022,53.445-71.391-3.975-35.527-39.5-61.485-74.692-54.585-44.586,8.738-66.269,57-43.386,96.3a10.553,10.553,0,0,1,.916,6.853C184.779,337.688,182.988,343.51,181.249,350.049Z",
    transform: "translate(0 0)",
    fill: "#674188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21123",
    "data-name": "Path 21123",
    d: "M205.373,227.1a24.014,24.014,0,0,1,14.566,43.2c-5.841,4.23-9.012,9.532-9.23,16.737a5.307,5.307,0,0,1-5.386,5.227,5.381,5.381,0,0,1-5.2-5.76c.234-9.931,4.187-18.024,12.348-23.849,3.856-2.754,6.193-6.28,6.314-11.093A13.17,13.17,0,0,0,206.326,237.8a13.346,13.346,0,0,0-14.254,12.345c-.031.333-.012.667-.05,1-.4,3.392-2.617,5.476-5.644,5.327s-4.975-2.433-5.009-5.872C181.241,237.933,192.284,227.124,205.373,227.1Z",
    transform: "translate(34.361 21.789)",
    fill: "#674188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21124",
    "data-name": "Path 21124",
    d: "M198.046,256.2A5.328,5.328,0,0,1,193,261.7a5.528,5.528,0,0,1-5.6-5.358,5.351,5.351,0,0,1,5.283-5.274A5.242,5.242,0,0,1,198.046,256.2Z",
    transform: "translate(47.118 72.471)",
    fill: "#674188"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInquiryChat);
export default __webpack_public_path__ + "static/media/InquiryChat.957977db8a9fcb8c5c8873255fd0a553.svg";
export { ForwardRef as ReactComponent };